module.exports = __webpack_public_path__ + "static/media/button-close-invert.eaa9e995.svg";